// Module
var code = "<p>Enable this setting to use RTL (Right to Left) on your questionnaire. Typically used in languages such as Arabic, Hebrew, Persian or Urdu.</p> ";
// Exports
module.exports = code;